module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//snow_4_3.png?v=0771fdd9";